import { useParams } from "react-router";
import FormUpdate from "../form/FormUpdate";
import FormCreate from "../form/FormCreate";
import { MainContainerForm, MainPadding } from "../../../styles/Main.styles";
import { Box, Tabs, Tab } from "@mui/material";
import React, { useState } from "react";
import StockAdjustment from "../form/FormStockAdjusment";
import StockHistory from "../form/__components/StockHistory";

export default function Creation() {
  const { idProduct } = useParams();
  const [tab, setTab] = useState(0);

  function CustomTabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  return (
    <MainPadding>
      {idProduct ? (
        <React.Fragment>
          <MainContainerForm mb={1}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tab}
                onChange={(e, v) => setTab(v)}
                aria-label="basic tabs example"
              >
                <Tab label="Pengaturan Produk" {...a11yProps(0)} />
                <Tab label="Pengaturan Stock" {...a11yProps(1)} />
                <Tab label="History Stock" {...a11yProps(2)} />
              </Tabs>
            </Box>
          </MainContainerForm>
          <CustomTabPanel value={tab} index={0}>
            <FormUpdate productId={idProduct} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={1}>
            <StockAdjustment productId={idProduct} />
          </CustomTabPanel>
          <CustomTabPanel value={tab} index={2}>
            <StockHistory productId={idProduct} />
          </CustomTabPanel>
        </React.Fragment>
      ) : (
        <FormCreate />
      )}
    </MainPadding>
  );
}
